import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import TncList from './TncList.page';
import { getListTnc } from '../../redux/actions/tnc';
import { resetFilter } from '../../../../redux/actions/newFilter';

const mapStateToProps = state => ({
  listTnc: state.allbiller.tncList,
  tncFilter: state.allbiller.tncListFilter,
  loading: state.allbiller.loading,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
});

const mapDispatchToProps = { resetFilter, getListTnc };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TncList));
